export default function ({ redirect, store, route }) {
    const { isLoggedIn } = store.getters;

    if (isLoggedIn && /(login|sign-up)/.test(route.name)) {
        return redirect('/');
    }
}
